module.exports = __webpack_public_path__ + "media/images/pages/brands-bg-99aabf2b124cc8257546a77b9fe7ad5a.png";